export default function BeneficesSection() {
  const benefices = [
    {
      title: 'Réguler la douleur',
      description: 'Pendant et autour de la pratique équestre',
      icon: 'ri-heart-pulse-line',
      bgColor: '#E8F4F8',
      details: 'Techniques spécifiques pour gérer la douleur avant, pendant et après la monte'
    },
    {
      title: 'Retrouver la mobilité',
      description: 'Bassin, dos et respiration',
      icon: 'ri-body-scan-line',
      bgColor: '#F0F0F0',
      details: 'Relâcher les zones clés sollicitées à cheval pour une équitation fluide'
    },
    {
      title: 'Restaurer la relation',
      description: 'Plus fluide et juste avec le cheval',
      icon: 'ri-heart-3-line',
      bgColor: '#F5EDE8',
      details: 'Permettre au cheval de retrouver un partenaire plus disponible'
    }
  ];

  return (
    <section id="benefices" className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Titre de section */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl text-center text-[#3D2817] mb-6 max-w-4xl mx-auto" style={{ fontFamily: 'Playfair Display, serif', letterSpacing: '0.01em' }}>
          Ce que permet concrètement cette formation
        </h2>
        
        <p className="text-lg text-[#6B6B6B] text-center max-w-2xl mx-auto mb-16">
          Grâce à la méthode Sophro Cavaliers, reprenez votre place et retrouvez votre plein potentiel
        </p>

        {/* Grille de 3 cartes */}
        <div className="grid md:grid-cols-3 gap-8">
          {benefices.map((benefice, index) => (
            <div key={index} className="flex flex-col">
              {/* Zone image/icône */}
              <div 
                className="rounded-3xl flex items-center justify-center mb-6 h-64"
                style={{ backgroundColor: benefice.bgColor }}
              >
                <div className="w-24 h-24 flex items-center justify-center">
                  <i className={`${benefice.icon} text-7xl text-[#3D2817]`}></i>
                </div>
              </div>

              {/* Informations */}
              <div className="text-center mb-4">
                <p className="text-sm text-[#6B6B6B] mb-2 font-medium">{benefice.description}</p>
                <h3 className="text-2xl md:text-3xl font-bold text-[#3D2817]">{benefice.title}</h3>
              </div>

              {/* Bouton action */}
              <button 
                className={`w-4/5 mx-auto py-4 rounded-full text-sm font-medium transition-all hover:shadow-lg whitespace-nowrap cursor-pointer ${
                  index === 0 
                    ? 'bg-[#1A1A1A] text-white hover:bg-black' 
                    : 'bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] hover:bg-gray-50'
                }`}
              >
                {benefice.title}
              </button>

              {/* Texte bas */}
              <p className="text-xs text-gray-400 text-center mt-4 px-4">
                {benefice.details}
              </p>
            </div>
          ))}
        </div>

        {/* Section résultats */}
        <div className="mt-20 bg-[#FAF7F4] rounded-3xl p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-[#3D2817] mb-2">La cavalière</div>
              <p className="text-[#6B6B6B]">reprend sa place</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#3D2817] mb-2">Le cheval</div>
              <p className="text-[#6B6B6B]">retrouve un partenaire disponible</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#3D2817] mb-2">La relation</div>
              <p className="text-[#6B6B6B]">s'apaise</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
